import { useEffect } from "react";
import { useMap } from "react-leaflet";

type Bounds = [number, number][];

// Componente que se encarga de actualizar los límites del mapa
const UpdateBounds = ({ bounds }: { bounds: Bounds }) => {
    const map = useMap();
    // Al actualizar los límites del mapa se ajusta el mapa
    useEffect(() => {
        if (bounds && bounds.length > 0) {
            map.fitBounds(bounds);
        }
    }, [bounds, map]);

    return null;
};

export default UpdateBounds;